import { LeadsPolicyModel } from '@herbjoy/apex-api-models'
import { getMarkerIcon } from './marker-icons'

export interface LeadsPolicyVM {
    leadsPolicyID: number;
    name: string;
    leadStatuses: LeadStatus[];
    markerIcon: {
        value: string;
        text: string;
        description: string;
    };
    minClusterZoom: number;
    maxClusterZoom: number;
    minSpiderZoom: number;
    maxSpiderZoom: number;
    minClickZoom: number;
    importInGroups: boolean;
    importGroupField?: string;
    defaultLeadExpiryLength?: number;
    defaultLeadExpiryLengthType?: string;
}


export interface LeadStatus {
    leadStatusID?: number;
    name: string;
    color: string;
    hue: number;
    isDefault: boolean;
    leadStatusType: number | string;
}

/**
 * Map a leads policy response into a view model.
 * @param {any} leadsPolicyResponse The source leads policy response data.
 */
export function mapLeadsPolicyToVM(leadsPolicyResponse: LeadsPolicyModel): Partial<LeadsPolicyVM> {
    return {
        leadsPolicyID: leadsPolicyResponse.LeadsPolicyID,
        name: leadsPolicyResponse.Name,
        leadStatuses: leadsPolicyResponse.LeadStatuses.map(status => ({
            leadStatusID: status.LeadStatusID,
            name: status.Name,
            color:  status.Color ? "#" + status.Color : null,
            hue: status.Hue,
            leadStatusType: status.LeadStatusType,
            isDefault: status.IsDefault
        })),
        markerIcon: getMarkerIcon(leadsPolicyResponse.MarkerIcon),
        minClusterZoom: leadsPolicyResponse.MinClusterZoom,
        maxClusterZoom: leadsPolicyResponse.MaxClusterZoom,
        minSpiderZoom: leadsPolicyResponse.MinSpiderZoom,
        minClickZoom: leadsPolicyResponse.MinClickZoom,
        importInGroups: leadsPolicyResponse.ImportInGroups,
        importGroupField: leadsPolicyResponse.ImportGroupField,
        defaultLeadExpiryLength: leadsPolicyResponse.DefaultLeadExpiryLength,
        defaultLeadExpiryLengthType: leadsPolicyResponse.DefaultLeadExpiryLengthType
    }
}

export function mapLeadsPolicySaveRequest(leadsPolicyVM) {
    return {
        LeadsPolicyID: leadsPolicyVM.leadsPolicyID,
        Name: leadsPolicyVM.name,
        LeadStatuses: leadsPolicyVM.leadStatuses.map(status => ({
            LeadStatusID: status.leadStatusID,
            Name: status.name,
            Color: status.color ? status.color.replace("#", "") : null,
            Hue: status.hue,
            LeadStatusType: status.leadStatusType,
            IsDefault: status.isDefault
        })),
        MarkerIcon: leadsPolicyVM.markerIcon ? leadsPolicyVM.markerIcon.value : null,
        MinClusterZoom: leadsPolicyVM.minClusterZoom,
        MaxClusterZoom: leadsPolicyVM.maxClusterZoom,
        MinSpiderZoom: leadsPolicyVM.minSpiderZoom,
        MinClickZoom: leadsPolicyVM.minClickZoom,
        ImportInGroups: leadsPolicyVM.importInGroups,
        ImportGroupField: leadsPolicyVM.importGroupField,
        DefaultLeadExpiryLength: leadsPolicyVM.defaultLeadExpiryLength,
        DefaultLeadExpiryLengthType: leadsPolicyVM.defaultLeadExpiryLengthType
    }
}
